import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "flex-center"
};
import SimpleActionSheet from "@/modules/vue/components/SimpleActionSheet.vue";
import SimpleActionSheetItem from "@/modules/vue/components/SimpleActionSheetItem.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'ActionButton',
  props: {
    division: null,
    divisions: null
  },
  setup(__props) {
    const props = __props;
    const route = useRoute();
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      const _component_NButton = _resolveComponent("NButton");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NButton, {
        text: "",
        onClick: _cache[0] || (_cache[0] = () => _ctx.$refs.simpleActionSheet.show())
      }, {
        default: _withCtx(() => [_createVNode(_component_Icon, {
          icon: _ctx.IconEnum.IosCog
        }, null, 8, ["icon"])]),
        _: 1
      }), _createVNode(SimpleActionSheet, {
        ref: "simpleActionSheet"
      }, {
        title: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('divisions')), 1)]),
        actions: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.divisions, d => {
          return _openBlock(), _createBlock(SimpleActionSheetItem, {
            key: d.id,
            "hide-on-click": "",
            to: {
              name: _unref(route).name,
              params: {
                id: d.id
              }
            },
            class: _normalizeClass({
              'font-bold': d.id === __props.division.id
            })
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(d.name), 1)]),
            _: 2
          }, 1032, ["to", "class"]);
        }), 128))]),
        _: 1
      }, 512)]);
    };
  }
});